YP.MenuDropdown = function() {

    var actionItem = $(".js-topnav--link");
    var linkList = $(".c-yf-topnav__list");
    var linkDropdown = $('.c-yf-topnav__list--link');
    var dropdown = $(".c-yf-topnav__list--dropdown");
    var mobile = $("#js-topnav--toggle");
    var mobileParticipant   = $(".c-header.t-header_nav_participant .c-header__more");
    var searchNavHide = $(".c-yf-topnav--search .s-cross");
    var searchNav = $(".c-yf-topnav--search");


    return {

        init: function() {

            actionItem.on("click",           this.doShowDropdown);
            mobile.on("click",               this.doShowMenuMobile);
            mobileParticipant.on("click",    this.doShowMenuMobileParticipant);
            searchNavHide.on("click",        this.doHideSearchNav);
            if(searchNav.length > 0) {
                $('.body-layout-pro').addClass('search-event');
                // $('.c-yf-topnav--mobile').css({
                //     'height': '120px'
                // });
            }

            $(window).scroll(function() {
                if ($(window).scrollTop() >= 30) {
                    $('.c-yf-topnav--pro').css({
                      'border-bottom': '1px solid #F0F2F6'
                    });
                }

                if ($(window).scrollTop() < 30){
                    $('.c-yf-topnav--pro').css({
                        border: 'none'
                    });
                }
            })
        },

        doHideSearchNav: function(e){
            searchNav.hide();
            $('.c-yf-topnav--mobile').css({
                'height': '60px'
            });
            $('.body-layout-pro').removeClass('search-event');
        },

        doShowDropdown: function(e){
            var itemMenuDropdown = $(this).parent();
            if(itemMenuDropdown.hasClass('is-visible')){
                itemMenuDropdown.removeClass('is-visible');
                linkDropdown.removeClass('is-hidden');
                dropdown.removeClass('is-visible');
            }
            else{
                actionItem.each(function(){
                    $(this).removeClass('is-visible');
                });
                itemMenuDropdown.addClass('is-visible');
                linkDropdown.addClass('is-hidden');
                dropdown.addClass('is-visible');
            }
        },

        doShowMenuMobile: function(e){
            e.preventDefault();
            var itemMenuDropdown2 = $(".c-yf-topnav");
            if($(this).hasClass('is-active')){
                $(this).removeClass('is-active');
                linkList.removeClass('is-active');
                $(itemMenuDropdown2).removeClass('is-active');
                $(".body-layout-pro").css({
                    'overflow': 'auto',
                    'position': 'inherit'
                });
            }

            else{
                $(this).addClass('is-active');
                linkList.addClass('is-active');
                $(itemMenuDropdown2).addClass('is-active');
                $(".body-layout-pro").css({
                    'overflow': 'hidden',
                    'position': 'fixed'
                });
            }
        },

        doShowMenuMobileParticipant: function(e){
            e.preventDefault();
            var itemMenuDropdown2 = $(".t-header_nav_participant .container_height");
            if($(itemMenuDropdown2).hasClass('is-active')){
                $(itemMenuDropdown2).removeClass('is-active');
            }
            else{
                $(itemMenuDropdown2).addClass('is-active');
            }
        }
    }
}


window.addEventListener("load", function(){
    YP.MenuDropdown().init();
});


